// Generated with util/create-component.js
import React from "react";
import { ModalProps } from "./Modal.types";
import { StyledModal, ModalTitleContainer, ModalTitle, ModalFooter } from "./Modal.styles";
import { StyleSheetManager } from "styled-components";
import isPropValid from "@emotion/is-prop-valid";

/**
 * Modal Component
 *
 * This component renders a modal dialog.
 *
 * @component
 *
 * @param {Object} ModalProps - The props for the Modal component.
 * @param {ReactNode} props.children - The content to be displayed within the modal.
 * @param {string} props.title - The title to be displayed at the top of the modal.
 * @param {boolean} props.show - A flag to control the visibility of the modal.
 * @param {React.MouseEventHandler<HTMLDivElement>} props.onClose - required onClose handler, will get called on click X or outside modal body.
 * @param {string} [props.footerMessage] - Optional footer message to display at the bottom of the modal.
 *
 * @returns {JSX.Element} Rendered Modal component.
 */

const Modal: React.FC<ModalProps> = ({ children, title, show, footerMessage, onClose }) => {
  return (
    <StyleSheetManager shouldForwardProp={isPropValid}>
      <StyledModal onClick={onClose}>
        <div className={`gs-modal ${!show && "hidden"}`} onClick={e => e.stopPropagation()}>
          <ModalTitleContainer>
            <ModalTitle>{title}</ModalTitle>
            <div className="close-button" onClick={onClose}>
              <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27" fill="none">
                <path d="M5.41422 4.58582L22.4142 21.5858" stroke="#FEC307" strokeWidth="4" />
                <path d="M22.4142 4.58582L5.41422 21.5858" stroke="#FEC307" strokeWidth="4" />
              </svg>
            </div>
          </ModalTitleContainer>
          <div className="gs-modal-content">
            {children}
            <ModalFooter>{footerMessage}</ModalFooter>
          </div>
        </div>
      </StyledModal>
    </StyleSheetManager>
  );
};

export default Modal;
